import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  FormControl,
  FormArray,
} from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { CatalogoService } from "src/app/services/catalogo.service";
import { ModalFichaTecnicaComponent } from "../modal-ficha-tecnica/modal-ficha-tecnica.component";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { Estado } from "src/app/models/entities/estado";
import { take, concatMap, map } from "rxjs/operators";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Usuario } from "src/app/models/entities/usuario";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import { ObraService } from "src/app/services/obra.service";
import { AlertasService } from "src/app/services/alertas.service";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { Obra } from "src/app/models/entities/obra";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { Alert } from "../../../../models/alert";

@Component({
  selector: "generador-ficha-tecnica",
  templateUrl: "./generador-ficha-tecnica.component.html",
  styleUrls: ["./generador-ficha-tecnica.component.scss"],
})
export class GeneradorFichaTecnicaComponent implements OnInit {
  public fichaTecnicaForm: FormGroup;
  public estados$: Observable<Estado[]>;
  public suscripcionObras: Subscription;
  public obras: LevantamientoObra[];
  public keyObraSeleccionada: string;
  public usuarioEnSesion: Usuario;
  public catTipoCarpetas$: Observable<ElementoCatalogo[]>;
  public catTipoSecciones$: Observable<ElementoCatalogo[]>;
  public catTipoPrioridad$: Observable<ElementoCatalogo[]>;
  public catTipoOrigenRecursos$: Observable<ElementoCatalogo[]>;
  public catTipoCorredor$: Observable<ElementoCatalogo[]>;
  public datosObra: ObraDTO;
  public catalogoEstados: Estado[] = [];
  // public urlIframeSanitizada: SafeResourceUrl;
  // public urlIframe: string;
  public mostrarMapaIframe: boolean = false;
  // public rutasFotosFull: any[] = [];
  // public rutasFotosAvance: any[] = [];
  // public rutasFotosEstructura: any[] = [];
  // public rutasFotosProblematica: any[] = [];

  public date: Date = new Date();
  public TIPO_OBRA_PROCESO: string = "0";
  periodoInicio: Date;
  periodoFin: Date;
  public anioActual: number = new Date().getFullYear() - 15;
  public idiomaCalendario: any;

  @ViewChild("modalFichaTecnica")
  public modalFichaTecnica: ModalFichaTecnicaComponent;

  @ViewChild("modalFichaTecnicaCapturada")
  public modalFichaTecnicaCapturada: any;
  public modalActivo: NgbModalRef;
  alert: Alert = new Alert();

  constructor(
    private formBuilder: FormBuilder,
    // private sanitizer: DomSanitizer,
    private levantamientoObraService: LevantamientoObraService,
    private catalogoService: CatalogoService,
    private obraService: ObraService,
    private facadeSesionService: FacadeSesionService,
    private alertasService: AlertasService,
    private modalService: NgbModal,
    private dateUtils: DateUtils
  ) {}

  public ngOnInit(): void {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Generar obra en proceso"
    );
    this.facadeSesionService.usuarioEnSesionService
      .obtenerUsuario()
      .subscribe(
        (usuarioSesionDTO: UsuarioSesionDTO) =>
          (this.usuarioEnSesion = usuarioSesionDTO.usuario)
      );
    this.inicializarFichaTecnicaForm();
    this.obtenerCatalogoEstados();
    this.obtenerEstados();
    this.idiomaCalendario = this.dateUtils.idiomaEspanol;
  }

  public async obtenerEstados(): Promise<any> {
    this.catalogoEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
  }

  private inicializarFichaTecnicaForm(): void {
    this.fichaTecnicaForm = this.formBuilder.group({
      estado: new FormControl("-1", [Validators.required, this.validateId]),
      keyLevantamientoObra: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      fechaActualizacion: new FormControl(this.date.getTime()),
      fechaCracion: new FormControl(this.date.getTime()),
      keyCatTipoPrioridad: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      keyCatOrigenRecursos: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      keyCatCorredor: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      caracteristicas: new FormControl("", [
        Validators.required,
        Validators.maxLength(500),
      ]),
      tpda: new FormControl("", [Validators.required]),
      keyCatCarpeta: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      keyCatSeccion: new FormControl("-1"),
      // periodoEjecucion: new FormControl(this.datosObra.obra.periodoEjecucion, [
      //   Validators.required,
      // ]),
      inicioPeriodoEjecucion: new FormControl(" ", [Validators.required]),
      finPeriodoEjecucion: new FormControl(" ", [Validators.required]),
      longitudTotal: new FormControl("", [Validators.required]),
      inversionTotal: new FormControl("", [Validators.required]),
      esquemaFinanciamiento: new FormControl("", [Validators.required]),
      registroSHCP: new FormControl("", [Validators.required]),
      estatusSHCP: new FormControl("", [Validators.required]),
      proyectoEjecutivo: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      liberacionDerechoVia: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      cus: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      mia: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      avanceFisicoGlobal: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      avanceFinancieroGlobal: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      avanceFisico: new FormControl("", [
        Validators.required,
        Validators.pattern("^((?:|0|[1-9]\\d?|100)(?:\\.\\d{1,2})?)$"),
      ]),
      avanceFinanciero: new FormControl("", [Validators.required]),
      observaciones: new FormControl("", [
        Validators.required,
        Validators.maxLength(500),
      ]),
      problematica: new FormControl("", [
        Validators.required,
        Validators.maxLength(500),
      ]),
      beneficios: new FormControl(" ", [
        Validators.required,
        Validators.maxLength(500),
      ]),
      proximasAcciones: new FormControl(" ", [
        Validators.required,
        Validators.maxLength(500),
      ]),
      incluyeImagenes: new FormControl(true),
      keyUsuario: new FormControl(this.usuarioEnSesion.key),
      ejerciciosFiscales: this.formBuilder.array(
        [this.crearFormEjercicioFiscal()],
        Validators.required
      ),
    });

    this.fichaTecnicaForm.get("keyLevantamientoObra").disable();

    this.fichaTecnicaForm
      .get("estado")
      .valueChanges.subscribe((keyEstado: string) => {
        if (keyEstado === "-1") {
          this.fichaTecnicaForm.get("keyLevantamientoObra").disable();
          this.fichaTecnicaForm.get("keyLevantamientoObra").setValue("-1");
          this.mostrarMapaIframe = false;
        } else {
          this.fichaTecnicaForm.get("keyLevantamientoObra").setValue("-1");
          this.fichaTecnicaForm.get("keyLevantamientoObra").enable();
          this.suscripcionObras = this.levantamientoObraService
            .findAprobadosByKeyEstadoAndTipoObra(
              keyEstado,
              this.TIPO_OBRA_PROCESO
            )
            .pipe(take(1))
            .subscribe((levantamientoObra: LevantamientoObra[]) => {
              this.obras = levantamientoObra;
            });
        }
      });

    this.fichaTecnicaForm
      .get("keyLevantamientoObra")
      .valueChanges.subscribe(async (keyObra: string) => {
        if (keyObra === "-1") {
          this.mostrarMapaIframe = false;
        } else {
          let obraValidar = await this.obraService
            .findByKeyLevantamientoObra(keyObra)
            .pipe(take(1))
            .toPromise();
          if (obraValidar == null) {
            this.obtenerCatalogos();
            this.mostrarMapaIframe = true;
          } else {
            this.abrirModal();
            this.mostrarMapaIframe = false;
          }
        }
      });
  }

  public validarCheck(checkValue: boolean) {
    if (!checkValue) {
      this.fichaTecnicaForm.get("incluyeImagenes").setValue(0);
    }
  }

  formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    switch (month) {
      case "01":
        month = "Enero";
        break;
      case "02":
        month = "Febrero";
        break;
      case "03":
        month = "Marzo";
        break;
      case "04":
        month = "Abril";
        break;
      case "05":
        month = "Mayo";
      case "06":
        month = "Junio";
      case "07":
        month = "Julio";
      case "08":
        month = "Agosto";
        break;
      case "09":
        month = "Septiembre";
        break;
      case "10":
        month = "Octubre";
        break;
      case "11":
        month = "Noviembre";
        break;
      case "12":
        month = "Diciembre";
        break;
    }

    return [month, year].join(" ");
  }

  // TODO: funcion a modificar
  public guardarFormato(obra): void {
    // Procesamiento de fecha periodo de ejecución
    this.alert.cargando();
    const { inicioPeriodoEjecucion, finPeriodoEjecucion, ...form } = obra;
    const periodoEjecucion = `${this.formatDate(
      inicioPeriodoEjecucion
    )} - ${this.formatDate(finPeriodoEjecucion)}`;
    const nuevaObra = { periodoEjecucion, ...form };
    // Aqui termina el proceso de fecha periodo de ejecucion
    this.obraService.save(nuevaObra).then(() => {
      console.log("Ficha guardada en firebase!");
      this.alert.closeLoading();
      this.alertasService.mostrarAlerta(
        "success",
        "Obra guardada correctamente."
      );
      this.limpiarFormularioFichaTecnica();
      // this.guardarFichaTenicaEnServidor(nuevaObra);
    });
  }

  guardarFichaTenicaEnServidor(obra) {
    this.levantamientoObraService
      .findByKey(obra.keyLevantamientoObra)
      .subscribe((obraLevantamiento: LevantamientoObra) => {
        const obraCompleta = {
          nombreObra: obraLevantamiento.nombreObra,
          nombreTramoLicitacion: obraLevantamiento.nombreTramoLicitacion,
          latitud: obraLevantamiento.latitud,
          longitud: obraLevantamiento.longitud,
          nombreEstado: this.catalogoEstados.find(
            (estados: Estado) => estados.key === obraLevantamiento.keyCatEstado
          ).nombre,
          ...obra,
        };
        // Guardando obraCompleta en el servidor SQL
        this.obraService.save2(obraCompleta).then(
          (data) => {
            console.log("Ficha guardada en servidor SQL!");
            this.alertasService.mostrarAlerta(
              "success",
              "Obra guardada correctamente."
            );
            this.limpiarFormularioFichaTecnica();
          },
          (err) => {
            this.alertasService.mostrarAlerta(
              "error",
              "Obra no se pudo guardar!."
            );
          }
        );
      });
  }

  public crearFormEjercicioFiscal(): FormGroup {
    return this.formBuilder.group({
      letrasEsquemaFiscal: new FormControl(""),
      esquemaFiscal: new FormControl(""),
      letrasAsignacion: new FormControl(""),
      asignacion: new FormControl(""),
      letrasMeta: new FormControl(""),
      meta: new FormControl(""),
    });
  }

  public agregarEjercicioFiscal(): void {
    (this.fichaTecnicaForm.get("ejerciciosFiscales") as FormArray).push(
      this.crearFormEjercicioFiscal()
    );
  }

  public eliminarEjercicioFiscal(indice: number): void {
    (<FormArray>this.fichaTecnicaForm.controls.ejerciciosFiscales).removeAt(
      indice
    );
  }

  public obtenerCatalogoEstados(): void {
    this.estados$ = this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1));
  }

  public obtenerCatalogos(): void {
    this.catTipoCarpetas$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CARPETAS)
      .pipe(take(1));
    this.catTipoSecciones$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SECCIONES)
      .pipe(take(1));
    this.catTipoPrioridad$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD)
      .pipe(take(1));
    this.catTipoOrigenRecursos$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.ORIGEN_RECURSOS)
      .pipe(take(1));
    this.catTipoCorredor$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CORREDORES)
      .pipe(take(1));
  }

  private validateId(control: AbstractControl) {
    return control.value === "-1" ? { error: "El campo es requerido" } : null;
  }

  public limpiarFormularioFichaTecnica(): void {
    this.fichaTecnicaForm.reset();
    this.inicializarFichaTecnicaForm();
  }

  public generarFichaTecnica(): Promise<Obra> {
    return new Promise((resolve, reject) => {
      let obra: Obra = this.crearModeloFichaTecnica(
        this.fichaTecnicaForm.value
      );
      resolve(obra);
    });
  }

  public crearModeloFichaTecnica(fichaTecnicaDeForm: any): Obra {
    let obra: Obra = Object.assign(fichaTecnicaDeForm) as Obra;
    return obra;
  }

  public abrirModalFichaTecnica(): void {
    this.generarFichaTecnica()
      .then(async (obra: Obra) => {
        this.datosObra = await this.levantamientoObraService
          .findByKey(obra.keyLevantamientoObra)
          .pipe(
            take(1),
            concatMap((levantamientoObra: LevantamientoObra) =>
              this.catalogoService
                .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
                .pipe(
                  take(1),
                  map((estados: Estado[]) => {
                    let estado: Estado = estados.find(
                      (estado: Estado) =>
                        estado.key === levantamientoObra.keyCatEstado
                    );
                    return {
                      nombreEstado: estado.nombre,
                      nombreObra: levantamientoObra.nombreObra,
                      nombreTramoLicitacion:
                        levantamientoObra.nombreTramoLicitacion,
                      obra,
                    } as ObraDTO;
                  })
                )
            ),
            take(1)
          )
          .toPromise();
        this.modalFichaTecnica.abrirModal(this.datosObra);
      })
      .catch(() => {
        console.error("Error al mapear datos de la obra.");
      })
      .finally(() => {});
  }

  public guardarFicha(): void {
    this.generarFichaTecnica()
      .then((obra: Obra) => {
        this.guardarFormato(obra);
      })
      .catch(() => {
        console.error("Error al generar ficha técnica.");
      })
      .finally(() => {});
  }

  public getErrorFicha(controlName: string): string {
    let error = "";
    const control = this.fichaTecnicaForm.get(controlName);
    if (control.touched && control.errors != null) {
      error = "El campo es requerido";
    }
    return error;
  }

  public abrirModal(): void {
    this.modalActivo = this.modalService.open(this.modalFichaTecnicaCapturada, {
      centered: true,
      size: "lg",
      windowClass: "modal-confirmacion",
    });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public ngOnDestroy(): void {
    if (this.suscripcionObras) {
      this.suscripcionObras.unsubscribe();
    }
  }
}
